export default "__VITE_ASSET__CSYsSdrI__"